
import ComboMealsModal from './ComboMealsModal'
import { Component, ProvideReactive, Prop, Vue, Watch, Emit } from "vue-property-decorator"
import { ElNotification } from "element-ui/types/notification";
import { mapGetters } from 'vuex'
import { eventHandler, translations } from '@/mixins'
import ComboMealItems from './ComboMealItems.vue'
import { Menu as MenuApi, Settings } from '@/services/SOLO';
import { Item as ItemModel } from '@/models'

@Component({
  components: {
    ComboMealItems,
    ComboMealsModal
  },
  mixins: [eventHandler, translations],
})
export default class ComboMeals extends Vue {
  
  open: Boolean = false
  updateData: Object = {}
  isUpdate: Boolean = false
  comboItems: Array<Object> = []
  @Prop() item!: ItemModel  
  translate!: Function;
  
  created() {
    this.getComboItems()
  }

  modalOpenState(open: Boolean = true) {    
    this.open = open
    this.isUpdate = false
    if(!open) {
      this.updateData = {}
    }
  }

    
  modalCloseState(open: Boolean = false) {    
    this.open = open
    this.isUpdate = false
    if(!open) {
      this.updateData = {}
    }
  }

  addComponent(component: Object = {}) {
    this.comboItems.unshift(component)
  }

  initUpdate(data: any) {
    this.isUpdate = true
    this.updateData = data
    this.open = true    
  }

  async getComboItems(){
    try {
      const response = await MenuApi.getComboItems(this.$route.params.id, this.$route.params.itemId)
      this.comboItems = response.data.data
    } catch (error) {
      console.error('Error in Getting Combo Items', error);
    }
  }

}
